import React from 'react';

const AddPlusFilledIcon = function AddPlusFilledIcon() {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="#1EC252" />
      <path d="M15.5554 8.91944H11.0805V4.44446H8.91932V8.91944H4.44434V11.0806H8.91932V15.5556H11.0805V11.0806H15.5554V8.91944Z" fill="white" />
    </svg>


  );
};
export default AddPlusFilledIcon;
